import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 14842517-5BC4-49B6-86F2-8D6DC8870786
 * name arrow-expand-all
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-expand-all.svg
 * tags
 * - Arrow 
 * - Geographic Information System 
 */
export const ArrowExpandAllIcon = createSvgIcon(<><path d="M9.5,13.09L10.91,14.5L6.41,19H10V21H3V14H5V17.59L9.5,13.09M10.91,9.5L9.5,10.91L5,6.41V10H3V3H10V5H6.41L10.91,9.5M14.5,13.09L19,17.59V14H21V21H14V19H17.59L13.09,14.5L14.5,13.09M13.09,9.5L17.59,5H14V3H21V10H19V6.41L14.5,10.91L13.09,9.5Z" /></>, 'ArrowExpandAllIcon');
export default ArrowExpandAllIcon